import Label from '@/service/label'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getsetsegments(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.getsetsegments(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getsetassigns(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.getsetassigns(payload), {
        type: 'list',
        success,
        fail
      })
    },
    downloadsetsegment(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.downloadsetsegment(payload), {
        type: 'file',
        success,
        fail
      })
    },
    addsetsegment(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.addsetsegment(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getnextsetsegmentinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.getnextsetsegmentinfo(payload), {
        type: 'info',
        success,
        fail
      })
    },
    assignpoolsetsegment(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.assignpoolsetsegment(payload), {
        type: 'action',
        success,
        fail
      })
    },

    gettagsegments(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.gettagsegments(payload), {
        type: 'list',
        success,
        fail
      })
    },
    gettagassigns(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.gettagassigns(payload), {
        type: 'list',
        success,
        fail
      })
    },
    downloadtagsegment(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.downloadtagsegment(payload), {
        type: 'file',
        success,
        fail
      })
    },
    addtagsegment(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.addtagsegment(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getnexttagsegmentinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.getnexttagsegmentinfo(payload), {
        type: 'info',
        success,
        fail
      })
    },
    assignpooltagsegment(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.assignpooltagsegment(payload), {
        type: 'action',
        success,
        fail
      })
    },
    gettagusedinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.gettagusedinfo(payload), {
        type: 'info',
        success,
        fail
      })
    },
    gettagcodes(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.gettagcodes(payload), {
        type: 'list',
        success,
        fail
      })
    },
    gettagprofile(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.gettagprofile(payload), {
        type: 'info',
        success,
        fail
      })
    },
    gettagassignuseddetails(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.gettagassignuseddetails(payload), {
        type: 'info',
        success,
        fail
      })
    },
    gettagassignsums(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.gettagassignsums(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getsetassignsums(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.getsetassignsums(payload), {
        type: 'list',
        success,
        fail
      })
    },
    gettagsegmentdetailses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.gettagsegmentdetailses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getsetsegmentdetailses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.getsetsegmentdetailses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    sumpooltags(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.sumpooltags(payload), {
        type: 'list',
        success,
        fail
      })
    },
    deassigntpooltagsegment(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.deassigntpooltagsegment(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getbadtags(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.getbadtags(payload), {
        type: 'list',
        success,
        fail
      })
    },
    addbadtags(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.addbadtags(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletebadtagbytagnoseg(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.deletebadtagbytagnoseg(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletebadtag(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.deletebadtag(payload), {
        type: 'action',
        success,
        fail
      })
    },
    gettagsegmentinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.gettagsegmentinfo(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatetagsegmentremarks(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Label.updatetagsegmentremarks(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
